import { render } from "./ShareModal.vue?vue&type=template&id=abff25ec&scoped=true&ts=true"
import script from "./ShareModal.vue?vue&type=script&lang=ts"
export * from "./ShareModal.vue?vue&type=script&lang=ts"

import "./ShareModal.vue?vue&type=style&index=0&id=abff25ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abff25ec"]])

export default __exports__